function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  id: "canvas_background",
  d: "M-1-1h510.7v87H-1z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "svg_1"
}, /*#__PURE__*/React.createElement("g", {
  id: "svg_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg_3",
  d: "M100.5 18.5c6.5 0 12.2 2.3 16.8 7 4.6 4.6 7 10.3 7 16.8 0 6.6-2.3 12.2-7 16.8-4.7 4.7-10.3 7-16.8 7h-11V18.5h11zm0 45.9c6.1 0 11.2-2.1 15.6-6.4 4.3-4.3 6.5-9.5 6.5-15.6s-2.2-11.3-6.5-15.6c-4.3-4.3-9.5-6.4-15.6-6.4h-9.2v44.1h9.2v-.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_4",
  d: "M130.5 66.2h-1.8V18.5h1.8v47.7z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_5",
  d: "M142 59.5c-4.8-4.7-7.1-10.4-7.1-17.2s2.4-12.4 7.1-17.2c4.7-4.8 10.4-7.1 17.2-7.1 3.3 0 6.4.6 9.5 1.9l-.7 1.6c-2.8-1.2-5.7-1.8-8.8-1.8-6.2 0-11.5 2.2-15.9 6.6-4.4 4.4-6.6 9.7-6.6 15.9 0 6.2 2.2 11.5 6.6 15.9 4.4 4.4 9.7 6.6 15.9 6.6 2.9 0 5.6-.5 8.3-1.6v-20h-11.9v-1.8h13.7v23.2l-.6.2c-3 1.3-6.2 1.9-9.5 1.9-6.8 0-12.5-2.3-17.2-7.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_6",
  d: "M177.4 66.2h-1.8V18.5h1.8v47.7z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_7",
  d: "M212.7 18.5v1.8H198v45.8h-1.8V20.3h-14.7v-1.8h31.2z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_8",
  d: "M237.9 18.5v47.6h-1.8V53.6h-21.6l-8 12.6h-2.1l8.9-14.1v-.3h.2l21-33.2h3.4v-.1zm-22.2 33.3h20.5V19.4l-20.5 32.4z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_9",
  d: "M246.2 18.5v45.8h22.6v1.8h-24.3V18.5h1.7z",
  className: "text-fill"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_10"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg_11",
  d: "M9.7 66.2V24.3h-8v-6.5h23v6.5h-8v41.9h-7z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_12",
  d: "M29.2 66.2V17.8h6.9v20.7h8.6V17.8h6.9v48.4h-6.9V44.6h-8.6v21.5h-6.9v.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_13",
  d: "M56.9 66.2V17.8h20.7v6.5H63.9v14.2h12V45h-12v14.2h13.7v6.9H56.9v.1z",
  className: "text-fill"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_14"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg_15",
  d: "M280 66.8V18.5h6.7l10.5 29.1h.1V18.5h6.9v48.4h-6.5l-10.6-29.1h-.1v29.1h-7v-.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_16",
  d: "M310.1 29.9c0-1.9.3-3.7 1-5.2s1.6-2.7 2.7-3.7 2.3-1.7 3.7-2.2c1.4-.5 2.8-.7 4.2-.7 1.4 0 2.8.2 4.2.7 1.4.5 2.6 1.2 3.8 2.2 1.1 1 2 2.2 2.6 3.7.7 1.5 1 3.2 1 5.2v25.5c0 2-.3 3.8-1 5.2-.7 1.5-1.6 2.7-2.6 3.6-1.1 1-2.4 1.7-3.8 2.2-1.4.5-2.8.7-4.2.7-1.4 0-2.8-.2-4.2-.7-1.4-.5-2.6-1.2-3.7-2.2-1.1-1-2-2.2-2.7-3.6-.7-1.4-1-3.2-1-5.2V29.9zm6.9 25.5c0 1.7.5 2.9 1.4 3.7.9.8 2 1.2 3.3 1.2 1.3 0 2.4-.4 3.3-1.2.9-.8 1.4-2 1.4-3.7V29.9c0-1.7-.5-2.9-1.4-3.7-.9-.8-2-1.2-3.3-1.2-1.3 0-2.4.4-3.3 1.2-.9.8-1.4 2-1.4 3.7v25.5z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_17",
  d: "M339.4 66.8V18.5h11.1c8.2 0 12.2 4.7 12.2 14.2 0 2.9-.4 5.3-1.3 7.3s-2.4 3.6-4.7 4.8l7.5 22.1H357l-6.5-20.7h-4.1v20.7h-7v-.1zm7-41.8v15.1h3.9c1.2 0 2.2-.2 2.9-.5.7-.3 1.3-.8 1.7-1.5.4-.6.6-1.4.7-2.3.1-.9.2-2 .2-3.2 0-1.2-.1-2.3-.2-3.2-.1-.9-.4-1.7-.8-2.4-.9-1.3-2.5-1.9-4.9-1.9h-3.5V25z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_18",
  d: "M373.2 66.8V25h-8v-6.5h23V25h-8v41.9h-7v-.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_19",
  d: "M391.9 66.8V18.5h6.9v20.7h8.6V18.5h6.9v48.4h-6.9V45.3h-8.6v21.5h-6.9z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_20",
  d: "M454.4 32.4h-6.9v-1.6c0-1.6-.4-3-1.1-4.1-.7-1.2-2-1.7-3.8-1.7-1 0-1.7.2-2.3.5-.6.4-1.1.8-1.4 1.4-.4.6-.6 1.3-.7 2-.1.7-.2 1.5-.2 2.3 0 1 0 1.7.1 2.4.1.6.2 1.2.5 1.7s.7.9 1.2 1.3 1.2.7 2.1 1.1l5.3 2.1c1.5.6 2.8 1.3 3.7 2.1 1 .8 1.7 1.7 2.2 2.8.5 1.1.8 2.3 1 3.7.2 1.4.3 3 .3 4.7 0 2-.2 3.9-.6 5.7-.4 1.7-1.1 3.2-2 4.5-1 1.3-2.2 2.3-3.7 3-1.5.7-3.4 1.1-5.6 1.1-1.7 0-3.2-.3-4.7-.9-1.5-.6-2.7-1.4-3.7-2.4s-1.9-2.3-2.5-3.6c-.6-1.4-.9-2.9-.9-4.5v-2.6h6.9v2.2c0 1.3.4 2.4 1.1 3.4.7 1 2 1.5 3.8 1.5 1.2 0 2.1-.2 2.8-.5.7-.3 1.2-.8 1.5-1.5.4-.6.6-1.4.6-2.3.1-.9.1-1.9.1-3 0-1.3 0-2.3-.1-3.1-.1-.8-.3-1.5-.5-2-.3-.5-.7-.9-1.3-1.2-.5-.3-1.2-.7-2.1-1l-5-2c-3-1.2-5-2.8-6-4.9-1-2-1.5-4.5-1.5-7.6 0-1.8.2-3.5.7-5.2.5-1.6 1.2-3 2.2-4.2 1-1.2 2.2-2.1 3.6-2.8 1.5-.7 3.2-1.1 5.3-1.1 1.7 0 3.3.3 4.7 1 1.4.6 2.7 1.5 3.7 2.5 2.1 2.2 3.1 4.7 3.1 7.5v3.3h.1z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_21",
  d: "M459.6 66.8V18.5h20.7V25h-13.7v14.2h12v6.5h-12v14.2h13.7v6.9h-20.7z",
  className: "text-fill"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_22",
  d: "M481.6 66.8l10.8-48.4h5.8L509 66.8h-6.9l-2-10.4h-9.4l-2 10.4h-7.1zm17.1-16.9l-3.4-17.5h-.1l-3.4 17.5h6.9z",
  className: "text-fill"
}))));

const SvgDigitalNorthSeaLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 85",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDigitalNorthSeaLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DigitalNorthSeaLogo.0eddbcf1.svg";
export { ForwardRef as ReactComponent };